import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../components/ExportToExcel";
import Pagination from "../../../components/Pagination";

const CreditDebitNoteReport = () => {
  const [data, setData] = useState([]);

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const FillSalesInvoices = () => {
    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    var tdate = moment(selectedToDate).format("DD/MM/YYYY");
    //console.log("fdate", fdate);

    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    var url = `/api/salesCreditDebit/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        //console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillSalesInvoices();
  }, [getprocurementData]);

  const fieldsToExport = [
    "date",
    "docNo",
    "salesReturnInvoiceDate",
    "salesReturnInvoiceNo",
    "salesReturnDate",
    "salesReturnNo",
    "executiveName",
    "name",
    "customerCode",
    "salesOrderCode",
    "salesOrderDate",
    "dndNo",
    "totalSalesOrderValue",
    "invoiceStatus",
    "delievryDispatchStatus",
    "deliveryDate",
    "salesInvoiceDate",
    "salesInvoiceNo",
    "containerNo",
    "billingAddress",
    "shippingAddress",
    "currencyName",
    "totalAmount",
    "taxName",
    "taxAmount",
    "totalCreditCostValue",
    "conditionOfItem",
    "reasonOfItem",
  ];

  const customHeaders = [
    "Date",
    "DocNo",
    "Sales Return Invoice Date",
    "Sales Return Invoice No",
    "Sales Return Date",
    "Sales Return No",
    "Executive Name",
    "Customer Name",
    "Customer Code",
    "Sales Order Code",
    "Sales Order Date",
    "Dnd No",
    "Total Sales Order Value",
    "Invoice Status",
    "Delievry Dispatch Status",
    "Delivery Date",
    "Sales Invoice Date",
    "Sales Invoice No",
    "Container No",
    "Billing Address",
    "Shipping Address",
    "Currency Name",
    "Total Amount",
    "Tax Name",
    "Tax Amount",
    "Total CreditCost Value",
    "Condition Of Item",
    "Reason Of Return",
  ];

  const handleExportExcel = () => {
    const filename = "CreditDebitNote.xlsx";
    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
            
              <label className="card-title mx-2 my-3"> &nbsp; &nbsp;Credit Debit Details </label>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-3 mx-3 my-2">
                {" "}
                <label htmlFor={"from_date"}>{"From Date"}</label>
                <input
                  type={"date"}
                  id={"date"}
                  required
                  // ref={(el) => (frmRef.current["pdate"] = el)}
                  className="form-control"
                  max={currentDate}
                  value={selectedFromDate}
                  onChange={handleFDateChange}
                />
              </div>

              <div className="col-md-3 mx-3 my-2">
                <label htmlFor={"to_date"}>{"To Date"}</label>

                <input
                  type={"date"}
                  id={"date"}
                  required
                  // ref={(el) => (frmRef.current["pdate"] = el)}
                  className="form-control"
                  max={currentDate}
                  value={selectedToDate}
                  onChange={handleTDateChange}
                />
              </div>

              <div className="col-md-3 mx-3 my-4">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={(e) => {
                    FillSalesInvoices();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>

          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Credit Note Date</th>

                          <th>Credit Note No</th>

                          <th>Sales Return Invoice Date</th>

                          <th>Sales Return Invoice No</th>

                          <th>Sales Return Date</th>

                          <th>Sales Return No</th>

                          <th>Executive Name</th>
                          <th> Customer Name </th>
                          <th> Customer No</th>
                          <th> Sales order No </th>
                          <th> Sales order Date</th>
                          <th> Delivery No</th>
                          <th> Delivery Date </th>
                          <th>Sales Invoice Date</th>

                          <th>Sales Invoice No</th>
                          <th> Container No </th>
                          <th>Biling Address </th>
                          <th> Shiping Address</th>
                          <th> Currency Name</th>

                          <th> Total Amount </th>
                          <th> Tax </th>

                          <th> Tax Amount </th>

                          <th> totalReturnCostValue</th>

                          <th> Condition Of Product </th>
                          <th> Reason Of Return</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.date}</td>
                                <td>{itm.docNo}</td>

                                <td>{itm.salesReturnInvoiceDate}</td>
                                <td>{itm.salesReturnInvoiceNo}</td>

                                <td>{itm.salesReturnDate}</td>
                                <td>{itm.salesReturnNo}</td>

                                <td>{itm.executiveName}</td>
                                <td>{itm.name}</td>
                                <td>{itm.customerCode}</td>

                                <td>{itm.salesOrderCode}</td>
                                <td>{itm.salesOrderDate}</td>
                                <td>{itm.dndNo}</td>

                                <td>{itm.deliveryDate}</td>
                                <td>{itm.salesInvoiceDate}</td>
                                <td>{itm.salesInvoiceNo}</td>

                                <td> {itm.containerNo} </td>
                                <td> {itm.billingAddress} </td>
                                <td> {itm.shippingAddress} </td>
                                <td> {itm.currencyName} </td>
                                <td> {itm.totalAmount} </td>
                                {/* <td> {itm.batch} </td> */}
                                <td> {itm.taxName} </td>
                                <td> {itm.taxAmount} </td>

                                <td> {itm.totalCreditCostValue} </td>
                                <td> {itm.conditionOfItem} </td>
                                <td> {itm.reasonOfItem} </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default CreditDebitNoteReport;
